/**
 * What can be laid over the media and moved and sized by hand: the climb's
 * card, the gym, the climb's name and its stats. A layout is a set of them
 * put down ready-placed (`TEMPLATE_STICKERS`).
 */
export type StickerKind = 'card' | 'gym' | 'name' | 'stats';

/** In the order they are offered, and drawn: the last on top. */
export const STICKER_KINDS: StickerKind[] = ['stats', 'name', 'gym', 'card'];
